import { render, staticRenderFns } from "./titleCountReview.vue?vue&type=template&id=00b9ad43&"
import script from "./titleCountReview.vue?vue&type=script&lang=js&"
export * from "./titleCountReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports